/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* -----------------------------------------------------------------------
   DIRECTIONAL ENTRANCE OBSERVER (T14)
   Adds .hds-entrance--visible when .hds-entrance elements scroll into
   view. Threshold 0.15 = fires when 15% of the element is visible.
   Respects prefers-reduced-motion by skipping entirely — elements that
   never get the class are already visible via the CSS fallback (the
   motion query only hides them when motion is allowed).
   ----------------------------------------------------------------------- */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('.hds-entrance');
  if (!targets.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hds-entrance--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  targets.forEach(function (el) { observer.observe(el); });
})();

/* -----------------------------------------------------------------------
   HEA SEARCH TOGGLE
   The B2B site has three headers (HEA, Paseo, Saturday), each with their
   own #Search div. Prestige's SearchBar class binds to getElementById('Search')
   which grabs the FIRST one (Saturday's, which is display:none on desktop).

   We use id="SearchHEA" on our search div to avoid the conflict, and wire
   up our own toggle/open/close logic here.
   ----------------------------------------------------------------------- */
(function () {
  var searchEl = document.getElementById('SearchHEA');
  if (!searchEl) return;

  var overlay = document.querySelector('.PageOverlay');
  var isOpen = false;

  var input = searchEl.querySelector('[name="q"]');

  function openSearch() {
    // Force the element fully visible inline BEFORE calling focus(), so
    // iOS Safari sees a visible input and opens the keyboard. Transitions
    // on visibility/max-height otherwise leave the element non-focusable
    // at the moment of the tap gesture.
    searchEl.style.visibility = 'visible';
    searchEl.style.opacity = '1';
    searchEl.style.maxHeight = 'none';
    searchEl.style.overflow = 'visible';
    searchEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open-HEA');
    if (overlay) overlay.classList.add('is-visible');
    isOpen = true;
    var headerSection = document.querySelector('#shopify-section-header');
    if (headerSection) headerSection.style.zIndex = '10';
    if (input) {
      searchEl.offsetHeight; // force layout
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    }
  }

  function closeSearch(e) {
    if (e) e.preventDefault();
    searchEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open-HEA');
    if (overlay) overlay.classList.remove('is-visible');
    isOpen = false;
    // Clear inline styles so CSS transitions take over on close
    searchEl.style.visibility = '';
    searchEl.style.opacity = '';
    searchEl.style.maxHeight = '';
    searchEl.style.overflow = '';
    var headerSection = document.querySelector('#shopify-section-header');
    if (headerSection) headerSection.style.zIndex = '';
    if (input) input.blur();
  }

  // Capture-phase click: intercept BEFORE Prestige's native SearchBar
  // delegate can fire. Otherwise both our handler AND Prestige's fire,
  // and Prestige opens the legacy #Search div from the Saturday header
  // as a "ghost" bar above the page.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-action="toggle-search"]');
    if (toggle && toggle.closest('.Header-HEA')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isOpen) { closeSearch(); } else { openSearch(); }
    }
    var close = e.target.closest('[data-action="close-search"]');
    if (close && searchEl.contains(close)) {
      e.stopImmediatePropagation();
      closeSearch(e);
    }
  }, true);

  // Close on overlay click
  if (overlay) {
    overlay.addEventListener('click', function () {
      if (isOpen) closeSearch();
    });
  }

  // Close on Escape key — preventDefault to beat the browser's default
  // "clear the search input" behavior, which otherwise swallows the key
  // without closing the modal.
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && isOpen) {
      e.preventDefault();
      closeSearch();
    }
  });
})();

/* -----------------------------------------------------------------------
   PASEO ROAD SEARCH TOGGLE
   Same pattern as HEA above, but for the Paseo Road header. Uses
   id="SearchPR" to avoid conflicts with HEA's #SearchHEA and any
   legacy #Search divs in the theme.
   ----------------------------------------------------------------------- */
(function () {
  var searchEl = document.getElementById('SearchPR');
  if (!searchEl) return;

  var overlay = document.querySelector('.PageOverlay');
  var isOpen = false;

  var input = searchEl.querySelector('[name="q"]');

  function openSearch() {
    searchEl.style.visibility = 'visible';
    searchEl.style.opacity = '1';
    searchEl.style.maxHeight = 'none';
    searchEl.style.overflow = 'visible';
    searchEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open-PR');
    if (overlay) overlay.classList.add('is-visible');
    isOpen = true;
    var headerSection = searchEl.closest('.shopify-section') || document.querySelector('.shopify-section--header-paseo');
    if (headerSection) headerSection.style.zIndex = '10';
    if (input) {
      searchEl.offsetHeight; // force layout
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    }
  }

  function closeSearch(e) {
    if (e) e.preventDefault();
    searchEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open-PR');
    if (overlay) overlay.classList.remove('is-visible');
    isOpen = false;
    searchEl.style.visibility = '';
    searchEl.style.opacity = '';
    searchEl.style.maxHeight = '';
    searchEl.style.overflow = '';
    var headerSection = searchEl.closest('.shopify-section') || document.querySelector('.shopify-section--header-paseo');
    if (headerSection) headerSection.style.zIndex = '';
    if (input) input.blur();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-action="toggle-search"]');
    if (toggle && toggle.closest('.Header-Paseo')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isOpen) { closeSearch(); } else { openSearch(); }
    }
    var close = e.target.closest('[data-action="close-search"]');
    if (close && searchEl.contains(close)) {
      e.stopImmediatePropagation();
      closeSearch(e);
    }
  }, true);

  if (overlay) {
    overlay.addEventListener('click', function () {
      if (isOpen) closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && isOpen) {
      e.preventDefault();
      closeSearch();
    }
  });
})();

/* ###########################################################################
   PORTED FROM B2C — 2026-04-25
   PDP gallery counter + active-thumb scroll-into-view + featured-review
   alignment, plus thumbnail-rail up/down arrow scroll handlers.
   Pairs with the Peacock Alley sticky-gallery CSS block in custom.css.
   Excludes the sticky-ATC bar block (separate sync entry, not yet ported).
   ########################################################################### */

/* -----------------------------------------------------------------------
   PDP GALLERY — COUNTER + ACTIVE-THUMB SCROLL-INTO-VIEW
   Prestige's Flickity carousel toggles .is-selected on the active
   .Product__SlideItem. We observe that class change via MutationObserver
   to (1) keep the "N / total" counter in sync and (2) scroll the vertical
   thumb rail so the matching active thumb is visible. The same handler
   catches arrow clicks, thumbnail clicks, swipes, AND variant-change
   jumps (Prestige re-selects the variant's featured slide).
   ----------------------------------------------------------------------- */
(function () {
  var slideshow = document.querySelector('.Product__Slideshow');
  var counter = document.querySelector('.Product__SlideshowCounter-current');
  var thumbNav = document.querySelector('.Product__SlideshowNav--thumbnails');
  var thumbScroller = thumbNav && thumbNav.querySelector('.Product__SlideshowNavScroller');
  if (!slideshow) return;

  function findActiveIndex() {
    var slides = slideshow.querySelectorAll('.Product__SlideItem');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-selected')) return i;
    }
    return -1;
  }

  function updateCounter() {
    if (!counter) return;
    var idx = findActiveIndex();
    if (idx >= 0) counter.textContent = idx + 1;
  }

  function scrollActiveThumbIntoView() {
    if (!thumbScroller) return;
    var idx = findActiveIndex();
    if (idx < 0) return;
    var thumbs = thumbScroller.querySelectorAll('.Product__SlideshowNavImage');
    var activeThumb = thumbs[idx];
    if (!activeThumb) return;

    /* Dual-axis: rail is vertical at desktop (flex-direction: column) and
       horizontal at sub-desktop (flex-direction: row). Detect via computed
       style and scroll the matching axis. */
    var isHorizontal = getComputedStyle(thumbScroller).flexDirection === 'row';
    var scrollerRect = thumbScroller.getBoundingClientRect();
    var thumbRect = activeThumb.getBoundingClientRect();

    if (isHorizontal) {
      if (thumbRect.left < scrollerRect.left || thumbRect.right > scrollerRect.right) {
        var leftOffset = activeThumb.offsetLeft - (thumbScroller.clientWidth / 2) + (activeThumb.clientWidth / 2);
        thumbScroller.scrollTo({ left: leftOffset, behavior: 'smooth' });
      }
    } else {
      if (thumbRect.top < scrollerRect.top || thumbRect.bottom > scrollerRect.bottom) {
        var topOffset = activeThumb.offsetTop - (thumbScroller.clientHeight / 2) + (activeThumb.clientHeight / 2);
        thumbScroller.scrollTo({ top: topOffset, behavior: 'smooth' });
      }
    }
  }

  /* Align the featured review card's right edge to the active image's right
     edge. Slideshow cell width is fixed (flex: 1), but images letterbox
     inside it via object-fit:contain when aspect ratios differ — so the
     <img> element box is wider than the rendered pixels. Compute the true
     displayed rect from naturalWidth/naturalHeight before sizing the review.
     Review left stays at thumb-rail left. */
  function getDisplayedImageRect(img) {
    var rect = img.getBoundingClientRect();
    var natW = img.naturalWidth, natH = img.naturalHeight;
    if (!natW || !natH || !rect.width || !rect.height) return rect;
    var scale = Math.min(rect.width / natW, rect.height / natH);
    var dispW = natW * scale, dispH = natH * scale;
    var insetX = (rect.width - dispW) / 2;
    var insetY = (rect.height - dispH) / 2;
    return {
      left: rect.left + insetX,
      right: rect.left + insetX + dispW,
      top: rect.top + insetY,
      bottom: rect.top + insetY + dispH,
      width: dispW,
      height: dispH
    };
  }

  function alignReviewToImage() {
    var review = document.querySelector('.Product__Gallery .product-featured-review-desktop');
    if (!review) return;
    /* Review is hidden on desktop via CSS (matches Peacock Alley which has no
       analogous element). Skip layout work when the element is not rendered. */
    if (!review.offsetParent) return;
    var activeImg = slideshow.querySelector('.Product__SlideItem.is-selected img');
    if (!activeImg || !activeImg.getBoundingClientRect().width) return;
    if (thumbNav) {
      var imgRect = getDisplayedImageRect(activeImg);
      var thumbRect = thumbNav.getBoundingClientRect();
      var gallery = review.parentElement;
      if (!gallery) return;
      var galleryRect = gallery.getBoundingClientRect();
      review.style.width = (imgRect.right - thumbRect.left) + 'px';
      review.style.marginLeft = (thumbRect.left - galleryRect.left) + 'px';
      review.style.flex = '0 0 auto';
    }
  }

  function onSlideChange() {
    updateCounter();
    scrollActiveThumbIntoView();
    alignReviewToImage();
  }

  onSlideChange();

  var observer = new MutationObserver(onSlideChange);
  slideshow.querySelectorAll('.Product__SlideItem').forEach(function (slide) {
    observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
  });

  /* Image/Flickity may finish initializing after this IIFE runs. Re-align on:
     - window.load (catches late image decode + Flickity's own load-time setup)
     - window.resize (viewport changes)
     - variant:changed (Prestige fires this when a swatch changes the gallery)
     - any newly-added slide image's load event
     Plus a deferred retry to cover the gap between init and Flickity adding
     .is-selected to the first slide. */
  window.addEventListener('load', alignReviewToImage);
  window.addEventListener('resize', alignReviewToImage);
  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(alignReviewToImage);
  });
  setTimeout(alignReviewToImage, 100);
  setTimeout(alignReviewToImage, 500);
  slideshow.querySelectorAll('.Product__SlideItem img').forEach(function (img) {
    if (img.complete) return;
    img.addEventListener('load', alignReviewToImage, { once: true });
  });
})();

/* -----------------------------------------------------------------------
   PDP THUMBNAIL RAIL — UP/DOWN SCROLL ARROWS
   Wires the up/down buttons to scroll the nearest thumbnail scroller
   by ~3 thumbnails per click (Peacock Alley-style pagination cue).
   ----------------------------------------------------------------------- */
(function () {
  var arrows = document.querySelectorAll('[data-thumbnail-nav]');
  if (!arrows.length) return;

  var SCROLL_STEP = 250; // ~3 thumbs at 76px + gap

  arrows.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = btn.closest('.Product__SlideshowNav--thumbnails');
      if (!nav) return;
      var scroller = nav.querySelector('.Product__SlideshowNavScroller');
      if (!scroller) return;
      var direction = btn.getAttribute('data-thumbnail-nav') === 'up' ? -1 : 1;
      scroller.scrollBy({ top: SCROLL_STEP * direction, behavior: 'smooth' });
    });
  });
})();
